import { useState } from "react";
import { Box, Card, Tab } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import PageContainer from "../../../components/container/PageContainer";
import Breadcrumb from "../../../layouts/full-layout/breadcrumb/Breadcrumb";
import AddApplication from "./AddApplication";
import AddModules from "./AddModules";
import AddSubModules from "./AddSubModules";
import ApplicationList from "./ApplicationList";
import VersionForm from "./VersionForm";

const ApplicationManagement = () => {
  const [value, setValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
  };

  const BCrumb = [
    { to: "/", title: "Admin" },
    { title: "Application Management" },
  ];

  return (
    <PageContainer title="Application Management">
      <Breadcrumb title="Application Management" items={BCrumb} />

      <Card>
        <TabContext value={value}>
          <Box
            sx={{
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <TabList onChange={handleTabChange} variant="fullWidth">
              <Tab label="Add Application" value="1" />

              <Tab label="Add Modules" value="2" />

              <Tab label="Add SubModules" value="3" />

              <Tab label="Application List" value="4" />

              <Tab label="Version Form" value="5" />
            </TabList>
          </Box>

          <TabPanel value="1">
            <AddApplication />
          </TabPanel>

          <TabPanel value="2">
            <AddModules />
          </TabPanel>

          <TabPanel value="3">
            <AddSubModules />
          </TabPanel>

          <TabPanel value="4">
            <ApplicationList />
          </TabPanel>

          <TabPanel value="5">
            <VersionForm />
          </TabPanel>
        </TabContext>
      </Card>
    </PageContainer>
  );
};

export default ApplicationManagement;
